var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('img',{staticClass:"rating-icon",class:{mlb2: _vm.mlb2},attrs:{"src":_vm.item.logo,"title":_vm.item.label}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }